RivalIQ.apps.Insights.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.FacebookAdsSyncStatus = Backbone.Model.extend({

        initialize: function (presenceId) {
            const me = this;

            me.presenceId = presenceId;
            me.firstStatusCheckCompleted = false;
            me.continuePolling = true;
            me.pollForAdsLoaded();
        },

        stopPolling: function () {
            const me = this;
            me.continuePolling = false;
        },

        handleAdsSyncStatus: function (status) {
            const me = this;

            if (!status) {
                return;
            }

            const companyPresence = _.find(status.presences, {
                facebook_presence_id: me.presenceId
            });

            // this is the check to see if we loaded ads from the very first time we got a token with ads_read
            const initialLoadComplete = _.get(companyPresence, 'fetched_initial_boosted_posts');

            // this checks if there's any new ad account loading going on, can happen anytime in the lifetime of an account.
            const adLoadsInflight = _.find(status.adAccountPullStatuses, {
                fetched_initial_boosted_posts: false,
                facebook_presence_id: me.presenceId
            });

            me.set('isLoadingAds', !initialLoadComplete || Boolean(adLoadsInflight));

            if (!me.firstStatusCheckCompleted) {
                me.knownAdAccountPullStatusIds = _.reduce(status.adAccountPullStatuses, function (memo, adAccountPullStatus) {
                    memo[adAccountPullStatus.id] = true;
                    return memo;
                }, {});
                me.firstStatusCheckCompleted = true;
                me.set('newAdAccountsFound', false);

            } else {
                // see if there are any new statuses that we didn't know about earlier.
                const newAdAccountsFound = _.find(status.adAccountPullStatuses, function (adAccountPullStatus) {
                    return (adAccountPullStatus.facebook_presence_id === me.presenceId &&
                        !_.get(me, ['knownAdAccountPullStatusIds', adAccountPullStatus.id]));
                });

                me.set('newAdAccountsFound', Boolean(newAdAccountsFound));
            }
        },

        pollForAdsLoaded: function () {
            const me = this;

            const api = function () {
                return $.getJSON('/api/insights/facebook/adssyncstatus');
            };

            const condition = function (status) {
                me.handleAdsSyncStatus(status);
                return !me.continuePolling;
            };

            const options = {
                pollingDelay: 5000,
                pollingMaxAttempts: -1,
                retry: true
            };

            return RivalIQ.utils.polling.pollUntilCondition(api, condition, options);
        }

    });

});
